export default "__VITE_ASSET__Bwg0nIfP__"